<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.5 23.5">
		<path d="M12.5 17A5.25 5.25 0 1 1 16 7.8374a.74969.74969 0 1 1-1 1.11719 3.74976 3.74976 0 1 0 0 5.59131.74969.74969 0 0 1 1 1.11719A5.24084 5.24084 0 0 1 12.5 17Z" transform="translate(-.25 -.25)"/>
		<path d="M11.25 11.75h-4.5a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 0 1.5Z" transform="translate(-.25 -.25)"/>
		<path d="M11.25 13.75h-4.5a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 0 1.5Z" transform="translate(-.25 -.25)"/>
		<path fill="currentColor" fill-rule="evenodd" d="M12 1.75A10.25 10.25 0 1 0 22.25 12 10.25 10.25 0 0 0 12 1.75ZM.25 12A11.75 11.75 0 1 1 12 23.75 11.75 11.75 0 0 1 .25 12Z" transform="translate(-.25 -.25)"/>
	</svg>
</template>
